(ns ui.editors.card.shared.entity-peek-editor
  (:require
   [common.localization :as loc]
   [ui.components.radio-group.view :as radio-group]
   [ui.editors.card.shared.sortable-field-list :as sortable-field-list]))

(def visible-fields-strategy-options
  [{:value :all-fields
    :content (loc/tr :card-editor/entity-peek-all-fields)}
   {:value :fields-that-have-value
    :content (loc/tr :card-editor/entity-peek-fields-that-have-value)}
   {:value :selected-fields
    :content (loc/tr :card-editor/entity-peek-selected-fields)}])

(defn view
  [{:keys [visible-fields-strategy visible-fields
           available-options
           set-visible-fields-strategy
           add-field
           remove-field
           reorder-fields]}]
  [:div
   {:class "flex flex-col gap-4"}
   [:div
    {:class "flex flex-col gap-2"}
    [:h5 
     {:class "text-semibold"}
     (loc/tr :card-editor/entity-peek-settings)]
    [:p
     {:class "text-sm m-0 text-base-light-text-paler"}
     (loc/tr :card-editor/entity-peek-description)]]
   [:div
    {:class "flex flex-col gap-2"}
    [:p
     {:class "text-semibold text-base-light-text"}
     (loc/tr :card-editor/which-fields-you-want-to-show)]
    [radio-group/radio-group-v2
     {:name (gensym)
      :orientation :horizontal
      :on-change set-visible-fields-strategy
      :checked visible-fields-strategy}
     visible-fields-strategy-options]]
   (when (= visible-fields-strategy :selected-fields)
     [sortable-field-list/view
      {:selected-options visible-fields
       :available-options available-options
       :add-field add-field
       :remove-field remove-field
       :reorder-items reorder-fields}])])
